exports = module.exports = require("../../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".textarea-view textarea {\n  width: 100%;\n  resize: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/@mprep/shared/lib/angular/components/question-view/text-views/textarea-view/textarea-view.scss
// module id = +04U
// module chunks = 3